// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_Dl4Rc","list_box":"index_list_box_iaIK2"};